var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-ua-green py-3 lh-1"},[_c('div',{staticClass:"container text-center"},[_c('a',{staticClass:"d-inline-block dv-ua-logo m-0 mb-3 mb-lg-0",attrs:{"href":"https://www.ualberta.ca/"}}),_c('div',{staticClass:"text-white text-lg-end"},[_c('small',[_vm._v("© "+_vm._s(_vm.copyrightYear)+" University of Alberta")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }